// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1RDFp","consentsList":"PatientConsents_consentsList__3ZO_j","consentsListEmpty":"PatientConsents_consentsListEmpty__1wQLw"};